module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"button_toggle_poi_visibility":"Toggle Point of Interest visibility","button_add_poi":"Add Point of Interest","message_select_on_map":"Select a location on the map for the Point of Interest."},"ko":{"button_toggle_poi_visibility":null,"button_add_poi":null,"message_select_on_map":null}}')
  delete Component.options._Ctor
}
